import React, { useEffect, useState } from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { DownloadOutlined, CloseOutlined, MobileOutlined } from '@ant-design/icons';
import { usePWA } from '../../Context/PWAContext';
import './index.scss';

const { Text, Title } = Typography;

const PWAInstallPrompt: React.FC = () => {
  const { 
    isInstalled, 
    canInstall, 
    showInstallPrompt, 
    setShowInstallPrompt, 
    installApp, 
    dismissInstallPrompt 
  } = usePWA();

  useEffect(() => {
    // Show prompt after a delay if can install and not installed
    if (canInstall && !isInstalled) {
      const timer = setTimeout(() => {
        // Check if user recently dismissed the prompt
        const dismissedTime = localStorage.getItem('pwa-prompt-dismissed');
        if (dismissedTime) {
          const timeSinceDismissed = Date.now() - parseInt(dismissedTime);
          if (timeSinceDismissed < 24 * 60 * 60 * 1000) { // 24 hours
            return;
          }
        }
        setShowInstallPrompt(true);
      }, 3000); // Show after 3 seconds

      return () => clearTimeout(timer);
    }
  }, [canInstall, isInstalled, setShowInstallPrompt]);

  // Don't show if already installed or prompt shouldn't be shown
  if (isInstalled || !showInstallPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt">
      <Card className="pwa-prompt-card">
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div className="pwa-prompt-header">
            <MobileOutlined className="pwa-icon" />
            <Title level={5} style={{ margin: 0 }}>
              Install QualifyMe App
            </Title>
            <Button
              type="text"
              icon={<CloseOutlined />}
              onClick={dismissInstallPrompt}
              className="pwa-close-btn"
            />
          </div>
          
          <Text type="secondary">
            Get the best experience by installing our app on your device. 
            Access it quickly from your home screen.
          </Text>
          
          <Space>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={installApp}
              size="large"
            >
              Install App
            </Button>
            <Button onClick={dismissInstallPrompt}>
              Maybe Later
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
};

export default PWAInstallPrompt; 